import styled from 'styled-components'

export const List = styled.div`
  background-color: white;
  border-radius: 10px;
  margin: 20px 0;
  li {
    flex-direction: row-reverse;
  }
`

export const AddDocument = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto 0;
`

export const InvalidAttachmentSize = styled.span`
  text-align: center;
  margin-bottom: 20px;
  color: #e31a12;
`

export const BackModal = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;

  div {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    width: 100%;
    button {
      width: 40%;
    }
  }
`

export const DocumentsArea = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  div {
    margin-right: 20px;
    margin-bottom: 20px;
  }
`

export const DocumentItem = styled.div`
  height: 140px;
  width: 140px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgba(30, 30, 30, 0.6);
  border: 4px solid ${({ theme }) => theme.colors.gray};
  border-radius: 10px;
  background-size: cover;
  position: relative;

  section {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  label {
    font-size: ${({ theme }) => theme.font.sizes.xxsmall};
    color: ${({ theme }) => theme.colors.white};
    font-weight: 600;
    text-align: center;
    max-width: 70%;
    margin-left: 4px;
  }

  p {
    font-size: ${({ theme }) => theme.font.sizes.xxsmall};
    color: ${({ theme }) => theme.colors.white};
    font-weight: 600;
    text-align: center;
    position: absolute;
    bottom: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 138px;
    padding: 4px 2px;
    background-color: ${({ theme }) => theme.colors.gray};
  }

  input {
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
  }
`

export const MultipleFileInputsWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  flex-wrap: wrap;

  margin-top: 24px;
`
